<template>
	<div>
		<div class="link-warp">
			<div :class="['link-item', { active: item.value === $route.path }]" v-for="item in navList"
				:key="item.value">
				{{ item.label }}
			</div>
			<div class="link-item"><Button v-if="toBack" class="goback btn-height45" @click="to">返回</Button>
			</div>
		</div>
		<div class="main">
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
	export default {
		name: "accountcontainer",
		data() {
			return {
				navList: [{
					active: true,
					value: "/customer/account",
					label: "个人资料",
				}, ],
				toBack: false,
			};
		},
		watch: {
			$route: {
				deep: true,
				immediate: true,
				handler(val) {
					console.log(val);
					let label = "";
					this.toBack = val.meta.toBack ? val.meta.toBack : false;
					switch (val.name) {
						case "account":
							label = "个人资料";
							break;
						case "accountSecurity":
							label = "安全中心";
							break;
						case "accountCertified":
							label = "我的认证";
							break;
						case "accountMail":
							label = "站内信";
							break;
						case "accountJournal":
							label = "登录日志";
							break;
						case "accountMyPersonal":
							label = "个人认证";
							break;
						case "accountMyEnterprise":
							label = "企业认证";
							break;
						case "accountMyEmail":
							label = "邮箱认证";
							break;
					}
					this.$set(this.navList, 0, {
						active: true,
						value: val.path,
						label: label,
					});
				},
			},
		},
		methods: {
			// 跳转路由
			onClick(val) {
				this.$router.push(val);
			},
			to() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style lang="less" scoped>
	.link-warp {
		padding: 0 15px;
		margin-top: 20px;

		.link-item {
			display: inline-block;
			height: 40px;
			line-height: 40px;
			padding: 0 30px;
			font-size: 16px;
			font-weight: 600;
			color: #4F5867;
			position: relative;
			cursor: pointer;
			transition: all 0.3s;
		}

		.link-item.active {
			color: #3992e9;
			font-weight: bold;
			border: 1px solid #759DE6;
		}
	}

	.main {
		margin: 20px 15px;
		padding: 20px;
		background: #fff;
	}

	.btn-height45 {
		height: 45px;
		line-height: 45px;
		min-width: 80px;
	}
</style>
